export default __webpack_public_path__ + "static/media/kfm_truck.e63b1021.jpg";